import { Injectable } from '@angular/core';
import { AuthData } from '../providers/auth';
import * as firebase from 'firebase';

@Injectable()

export class ClientData {

  constructor(public auth: AuthData) {}

  searchClient(token, child) {
    let q = firebase.database().ref('/ClientList/').orderByChild(child).equalTo(token.toLowerCase()).limitToFirst(1);

    return new Promise((resolve, reject) => {
      q.once('value').then((snapshot) => {
        if (snapshot.val()) {
          snapshot.forEach(childSnapshot => {
            resolve(childSnapshot.val());
          });
        } else {
          reject(false);
        }
      });
    })
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/client.ts